import * as T from '@clientos/types';
import BreadcrumbInterfaceV1 from './BreadcrumbInterfaceV1';

export { createNoopBreadcrumbInterface } from './NoopInterface';

let breadcrumbInterfaceV1: BreadcrumbInterfaceV1;

export function getBreadcrumbInterfaceV1(): T.BreadcrumbInterfaceType {
  return breadcrumbInterfaceV1.getInterface();
}

export default async function initializeBreadcrumbInterfaceV1(): Promise<T.BreadcrumbInterfaceType> {
  if (breadcrumbInterfaceV1) return breadcrumbInterfaceV1.getInterface();
  breadcrumbInterfaceV1 = new BreadcrumbInterfaceV1();

  return breadcrumbInterfaceV1.getInterface();
}
